import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { OffersService } from '../services/offers.service';
import { RouteHelperService } from '../../core/services/route-helper.service';
import { LocationService } from '../../locations/services/location.service';
import { config } from '../../app.config';
import { OfferTypeService } from '../../offer-types/services/offer-types.service';
import { AuthDataStorageService } from '../../auth/services/auth-data-storage.service';
import * as moment from 'moment';
import { setTimeout } from 'timers';
import { PageParamStorageService } from '../../core/services/page-param-storage.service';
import { OfferTypeLabelEnum } from '../interfaces/offer.interfaces';
import { TagsService } from '../../tags/services/tags.service';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'ch-offers-list',
  templateUrl: './offers-list.component.html',
  styleUrls: ['./offers-list.component.css'],
})
export class OffersListComponent implements OnInit, OnDestroy {
  public items = [];
  public totalItems;
  public pageParams: any = {
    status: 'PUBLISHED',
  };
  public showExportDialog = false;
  public exportData: any = {};

  public exportingExcel: boolean;
  public loading: boolean;
  public typesFilter = [];
  public offerTypes: any[] = [];
  public tagsFilter = [];
  public offerTags: any[] = [];
  public filterFields: string[] = [
    'locationId',
    'type',
    'tag',
    'search',
    'expiry',
    'status',
    'isAvailableOnMonday',
    'isAvailableOnTuesday',
    'isAvailableOnWednesday',
    'isAvailableOnThursday',
    'isAvailableOnFriday',
    'isAvailableOnSaturday',
    'isAvailableOnSunday',
  ];
  public expiryDateFilters = [
    {
      name: 'Expiry',
      value: null,
    },
    {
      name: 'Next 7 days',
      value: 'SEVEN_DAYS',
    },
    {
      name: 'Next 30 days',
      value: 'ONE_MONTH',
    },
  ];
  public checkboxValues = [
    { value: 'Sun', checked: false },
    { value: 'Mon', checked: false },
    { value: 'Tue', checked: false },
    { value: 'Wed', checked: false },
    { value: 'Thu', checked: false },
    { value: 'Fri', checked: false },
    { value: 'Sat', checked: false },
  ];
  public locations: any[] = [];

  constructor(
    private router: Router,
    private offersService: OffersService,
    private activatedRoute: ActivatedRoute,
    private locationService: LocationService,
    private offerTypeService: OfferTypeService,
    private offerTagService: TagsService,
    private pageParamStorageService: PageParamStorageService,
    private routeHelperService: RouteHelperService,
    private authDataStorageService: AuthDataStorageService,
    private titleService: Title,
  ) { }

  ngOnInit() {
    this.titleService.setTitle(`Offers | CODE Hospitality CMS`);
    this.activatedRoute.queryParamMap
      .map((params: Params) => params.params)
      .subscribe(params => {
        if (Object.keys(params).length === 0 && this.pageParamStorageService.pageParams) {
          params = this.pageParamStorageService.pageParams;
          this.queryParams(params);
        }

        this.pageParams = this.routeHelperService.getValidatedParams(params);
        this.loadItems(this.pageParams);
        this.pageParamStorageService.pageParams = this.pageParams;
      });

    this.locationService.getLocationData().then((resp: any[]) => {
      resp.unshift({
        id: '',
        value: 'All Locations',
      });
      this.locations = resp;
    });

    this.offerTypeService.getOfferTypes().subscribe(resp => {
      const result = [
        {
          name: 'All Types',
          value: '',
        },
      ];
      const items = resp.json();
      items.forEach(item => {
        result.push({ name: item.name, value: item.id });
      });

      this.offerTypes = result;
    });

    this.offerTagService.getAllTags().subscribe(resp => {
      const result = [
        {
          name: 'Nothing selected',
          value: null
        }
      ]
      const items = resp.json();
      items.forEach(item => {
        result.push({ name: item, value: item });
      });

      this.offerTags = result;
    });
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  public addNew() {
    this.router.navigate(['/admin/offers/add']);
  }

  public checkboxChange(index) {
    this.checkboxValues.forEach(value => {
      const checked = value === index;
      if (checked) {
        this.checkboxValueSelected(value);
      }
      value['checked'] = !checked ? false : true;
    });
  }

  statusChanged(_: any, value: string) {
    this.filterSearch({ status: this.pageParams.status === value ? '' : value });
  }

  public dayChanged(event) {
    const except: string[] = [];
    const allDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    for (const day of allDays) {
      if (0 <= event.allSelected.indexOf(day)) {
        continue;
      }
      switch (day) {
        case 'Mon':
          except.push('isAvailableOnMonday');
          break;
        case 'Tue':
          except.push('isAvailableOnTuesday');
          break;
        case 'Wed':
          except.push('isAvailableOnWednesday');
          break;
        case 'Thu':
          except.push('isAvailableOnThursday');
          break;
        case 'Fri':
          except.push('isAvailableOnFriday');
          break;
        case 'Sat':
          except.push('isAvailableOnSaturday');
          break;
        case 'Sun':
          except.push('isAvailableOnSunday');
          break;
      }
    }

    this.filterSearch(this.checkboxValueSelected(event.allSelected), except);
  }

  private checkboxValueSelected(values) {
    const data: any = {};
    for (const item of values) {
      switch (item) {
        case 'Mon':
          data.isAvailableOnMonday = true;
          break;
        case 'Tue':
          data.isAvailableOnTuesday = true;
          break;
        case 'Wed':
          data.isAvailableOnWednesday = true;
          break;
        case 'Thu':
          data.isAvailableOnThursday = true;
          break;
        case 'Fri':
          data.isAvailableOnFriday = true;
          break;
        case 'Sat':
          data.isAvailableOnSaturday = true;
          break;
        case 'Sun':
          data.isAvailableOnSunday = true;
          break;
      }
    }

    return data;
  }

  public locationChanged(event) {
    if (!event || !event.target) {
      return;
    }
    this.filterSearch({
      locationId: event.target.value,
    });
  }

  public typeChanged(event) {
    const value = event.target.value;
    this.filterSearch({
      type: value,
    });
  }

  public tagChanged(event) {
    const value = event.target.value;
    this.filterSearch({
      tag: value,
    });
  }

  public expiryChanged(event) {
    const value = event.target.value;
    this.filterSearch({
      expiry: value,
    });
  }

  public search(event) {
    this.filterSearch({
      search: event,
    });
  }

  public clearFilters() {
    this.pageParams = { pageSize: this.pageParams.pageSize };
    this.pageParamStorageService.pageParams = this.pageParams;
    this.filterSearch({}, this.filterFields);
  }

  private filterSearch(data, except = []) {
    const result = {};
    for (const i of this.filterFields) {
      result[i] = null != data[i] ? data[i] : this.pageParams[i];
    }
    for (const i of except) {
      delete result[i];
    }

    this.router.navigate([], { queryParams: result });
  }

  public onSort(data) {
    this.queryParams({
      sortBy: data.column,
      sortOrder: data.order,
    });
  }

  public onPageChanged(page) {
    this.queryParams({
      pageNumber: page.pageNumber,
      pageSize: page.pageSize,
    });
  }

  private queryParams(params) {
    const result = this.routeHelperService.queryParams(params, this.pageParams);
    this.router.navigate([], { queryParams: result });
  }

  private loadItems(data) {
    this.loading = true;
    this.offersService.getOffers(data).subscribe(result => {
      const headers = result.headers;

      const setCookieHeader = headers.get('Set-Cookie');
      const jsonData = result.json();
      this.items = jsonData.items;
      this.totalItems = jsonData.totalItems;
      this.loading = false;
    });
  }

  public exportOffer(offerId: string) {
    this.exportData.title = this.items.map(offer => {
      if (offerId === offer.id) {
        this.exportData = {
          offerId: offer.id,
          title: offer.establishmentName + ' / ' + offer.headline,
        };
      }
    });

    this.showExportDialog = true;
  }

  public onExport(data) {
    let ti = null;
    for (const item of this.items) {
      if (item.id === data.offerId) {
        ti = item;
        item.exporting = true;
        break;
      }
    }

    const exportQueryString = this.getOfferExportQueryString(data.offerId, data.period);
    const exportFilename = this.getExportFilename(ti.establishmentName, data);

    this.downloadUrlFile(exportQueryString, exportFilename).then(() => {
      if (ti) {
        ti.exporting = false;
      }
    });
  }

  private getExportFilename(establishmentName: string, data: any) {
    const dateFormat = 'DD-MM-YYYY';

    const startDate = moment(data.period.start).format(dateFormat);
    const endDate = moment(data.period.end).format(dateFormat);
    const establishment = establishmentName
      .replace(/[^0-9a-zA-Z\s\-_]+/g, ' ')
      .trim()
      .replace(/\s+/g, '-');

    return `${establishment}-offers-report-${startDate}-${endDate}.pdf`;
  }

  public downloadReport() {
    const url = `${this.apiUrl}offers/report?${this.queryString}`;

    this.exportingExcel = true;
    this.downloadExcelFile(url, `offers-report-${moment().format('DD-MM-YYYY')}.xlsx`);
  }

  private downloadExcelFile(url, filename) {
    return this.downloadUrlFile(url, filename).then(() => {
      this.exportingExcel = false;
    });
  }

  private downloadUrlFile(url, filename) {
    return fetch(url, {})
      .then(r => r.blob())
      .then((blob: any) => {
        const newBlob = new Blob([blob], { type: 'application/pdf' });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }

        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = data;
        const d = new Date();
        link.download = filename;
        link.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(data);
        }, 100);
      });
  }

  public onCloseExportDialog() {
    this.showExportDialog = false;
  }

  get getOfferExportUrl() {
    return this.apiUrl + 'offers/offer-report?' + this.queryString;
  }

  public getOfferExportQueryString(offerId: string, period: { start: string; end: string }) {
    return (
      this.apiUrl +
      'offers/offer-report?' +
      this.routeHelperService.buildQueryString(
        {
          'x-auth-token': this.authDataStorageService.getSessionTokenFromStorage(),
          offerId: offerId,
          startDate: period.start,
          endDate: period.end,
        },
        ['pageSize', 'pageNumber']
      )
    );
  }

  get queryString() {
    return this.routeHelperService.buildQueryString(
      {
        'x-auth-token': this.authDataStorageService.getSessionTokenFromStorage(),
        offerId: 'e68e2ea8-6156-434b-9ea6-94d1ddd8b669',
        startDate: '2018-01-01',
        endDate: '2018-03-01',
        ...this.pageParams,
      },
      ['pageSize', 'pageNumber']
    );
  }

  get apiUrl() {
    return config.api_url;
  }

  offerTypeLabel(offerType) {
    return OfferTypeLabelEnum[offerType];
  }

  get selectedDays() {
    const result: string[] = [];
    Object.keys(this.pageParams).forEach(param => {
      switch (param) {
        case 'isAvailableOnMonday':
          result.push('Mon');
          break;
        case 'isAvailableOnTuesday':
          result.push('Tue');
          break;
        case 'isAvailableOnWednesday':
          result.push('Wed');
          break;
        case 'isAvailableOnThursday':
          result.push('Thu');
          break;
        case 'isAvailableOnFriday':
          result.push('Fri');
          break;
        case 'isAvailableOnSaturday':
          result.push('Sat');
          break;
        case 'isAvailableOnSunday':
          result.push('Sun');
          break;
      }
    });

    return result;
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/offers/offers-list/offers-list.component.ts